import deepmerge from "deepmerge";
import bridgeSvg from '@/assets/bridge.svg'

const overwriteMerge = (destinationArray, sourceArray) => sourceArray

export const mapHelper = {
    data: function () {
        return {
            VEHICLE: 1,
            OBSERVATION: 2,
            EQUIPMENT: 3,
            OTHER: 4,
            USER: 5,
            PERSON: 6,
            ROAD: 7,
            TRACE: 8,
            SKI_TRACK: 9,
            MATERIAL_STORAGE: 10,
            USER_ALERT: 11,
            WORK_TRACE: 12,
            TRAFFIC_SIGN: 13,
            MATERIAL_STATION: 14,
            BRIDGE: 15,
            CULVERT: 16,
            WORK_ASSIGNMENT: 17,
            MEASURE_DISTANCE: 18,
            IMPORTED_SHAPE: 19,
            MEASURE_ROAD: 20,
            AREA: 21,
            USER_LOCATION: 22,
            POWER_CENTER: 23,
            STREET_LIGHT: 24,
            SEWERS: 25,
            DRAINS: 26,
            TRAFFIC_CONTROL_ITEM: 28,
            EXTERNAL_TRAFFIC_SIGNS: 29,
            EXTERNAL_POSTS: 30,
            EXTERNAL_CULVERTS: 31,
            EXTERNAL_RAILINGS: 32,
            SPREADER_DATA: 33,
            EXTERNAL_PORTALS: 34,
            EXTERNAL_DRAINS: 35,
            EXTERNAL_FENCES: 36,
            EXTERNAL_STAIRS: 37,
            EXTERNAL_GATES: 38,
            EXTERNAL_EDGE_SUPPORTS: 39,
            EXTERNAL_EDGE_PILES: 40,
            EXTERNAL_ROADSIDE_FURNITURE: 41,
            EXTERNAL_ROADSIDE_ADVERTISEMENTS: 42,
            EXTERNAL_LIGHTING: 43,
            EXTERNAL_BOOMS_BARRIERS_AND_BOLLARDS: 44,
            EXTERNAL_PIPES_WIRES_AND_CABLES: 45,
            HARJA_MESSAGES: 46,
            WEATHER_STATION: 47,
            CABLE: 48,
            MIXED_WASTE_BINS: 49,
            mouseCoordinate: null,
            roadNames: ['roadName', 'name', 'nimi', 'tie_nimi', 'MT_TIENIMI', 'TIENIMI_SU'],
            excludedFields: ['id', 'importedItemIndex', 'selected', 'index', 'objectIndex'],
            cityOptions: [
                { value: null, text: this.$t('sports.select_city') },
                { value: 20, text: 'Akaa' },
                { value: 5, text: 'Alajärvi' },
                { value: 9, text: 'Alavieska' },
                { value: 10, text: 'Alavus' },
                { value: 16, text: 'Asikkala' },
                { value: 18, text: 'Askola' },
                { value: 19, text: 'Aura' },
                { value: 35, text: 'Brändö' },
                { value: 43, text: 'Eckerö' },
                { value: 46, text: 'Enonkoski' },
                { value: 47, text: 'Enontekiö' },
                { value: 49, text: 'Espoo' },
                { value: 50, text: 'Eura' },
                { value: 51, text: 'Eurajoki' },
                { value: 52, text: 'Evijärvi' },
                { value: 60, text: 'Finström' },
                { value: 61, text: 'Forssa' },
                { value: 62, text: 'Föglö' },
                { value: 65, text: 'Geta' },
                { value: 69, text: 'Haapajärvi' },
                { value: 71, text: 'Haapavesi' },
                { value: 72, text: 'Hailuoto' },
                { value: 74, text: 'Halsua' },
                { value: 75, text: 'Hamina' },
                { value: 76, text: 'Hammarland' },
                { value: 77, text: 'Hankasalmi' },
                { value: 78, text: 'Hanko' },
                { value: 79, text: 'Harjavalta' },
                { value: 81, text: 'Hartola' },
                { value: 82, text: 'Hattula' },
                { value: 86, text: 'Hausjärvi' },
                { value: 111, text: 'Heinola' },
                { value: 90, text: 'Heinävesi' },
                { value: 91, text: 'Helsinki' },
                { value: 97, text: 'Hirvensalmi' },
                { value: 98, text: 'Hollola' },
                { value: 102, text: 'Huittinen' },
                { value: 103, text: 'Humppila' },
                { value: 105, text: 'Hyrynsalmi' },
                { value: 106, text: 'Hyvinkää' },
                { value: 108, text: 'Hämeenkyrö' },
                { value: 109, text: 'Hämeenlinna' },
                { value: 139, text: 'Ii' },
                { value: 140, text: 'Iisalmi' },
                { value: 142, text: 'Iitti' },
                { value: 143, text: 'Ikaalinen' },
                { value: 145, text: 'Ilmajoki' },
                { value: 146, text: 'Ilomantsi' },
                { value: 153, text: 'Imatra' },
                { value: 148, text: 'Inari' },
                { value: 149, text: 'Inkoo' },
                { value: 151, text: 'Isojoki' },
                { value: 152, text: 'Isokyrö' },
                { value: 165, text: 'Janakkala' },
                { value: 167, text: 'Joensuu' },
                { value: 169, text: 'Jokioinen' },
                { value: 170, text: 'Jomala' },
                { value: 171, text: 'Joroinen' },
                { value: 172, text: 'Joutsa' },
                { value: 176, text: 'Juuka' },
                { value: 177, text: 'Juupajoki' },
                { value: 178, text: 'Juva' },
                { value: 179, text: 'Jyväskylä' },
                { value: 181, text: 'Jämijärvi' },
                { value: 182, text: 'Jämsä' },
                { value: 186, text: 'Järvenpää' },
                { value: 202, text: 'Kaarina' },
                { value: 204, text: 'Kaavi' },
                { value: 205, text: 'Kajaani' },
                { value: 208, text: 'Kalajoki' },
                { value: 211, text: 'Kangasala' },
                { value: 213, text: 'Kangasniemi' },
                { value: 214, text: 'Kankaanpää' },
                { value: 216, text: 'Kannonkoski' },
                { value: 217, text: 'Kannus' },
                { value: 218, text: 'Karijoki' },
                { value: 224, text: 'Karkkila' },
                { value: 226, text: 'Karstula' },
                { value: 230, text: 'Karvia' },
                { value: 231, text: 'Kaskinen' },
                { value: 232, text: 'Kauhajoki' },
                { value: 233, text: 'Kauhava' },
                { value: 235, text: 'Kauniainen' },
                { value: 236, text: 'Kaustinen' },
                { value: 239, text: 'Keitele' },
                { value: 240, text: 'Kemi' },
                { value: 320, text: 'Kemijärvi' },
                { value: 241, text: 'Keminmaa' },
                { value: 322, text: 'Kemiönsaari' },
                { value: 244, text: 'Kempele' },
                { value: 245, text: 'Kerava' },
                { value: 249, text: 'Keuruu' },
                { value: 250, text: 'Kihniö' },
                { value: 256, text: 'Kinnula' },
                { value: 257, text: 'Kirkkonummi' },
                { value: 260, text: 'Kitee' },
                { value: 261, text: 'Kittilä' },
                { value: 263, text: 'Kiuruvesi' },
                { value: 265, text: 'Kivijärvi' },
                { value: 271, text: 'Kokemäki' },
                { value: 272, text: 'Kokkola' },
                { value: 273, text: 'Kolari' },
                { value: 275, text: 'Konnevesi' },
                { value: 276, text: 'Kontiolahti' },
                { value: 280, text: 'Korsnäs' },
                { value: 284, text: 'Koski Tl' },
                { value: 285, text: 'Kotka' },
                { value: 286, text: 'Kouvola' },
                { value: 287, text: 'Kristiinankaupunki' },
                { value: 288, text: 'Kruunupyy' },
                { value: 290, text: 'Kuhmo' },
                { value: 291, text: 'Kuhmoinen' },
                { value: 295, text: 'Kumlinge' },
                { value: 297, text: 'Kuopio' },
                { value: 300, text: 'Kuortane' },
                { value: 301, text: 'Kurikka' },
                { value: 304, text: 'Kustavi' },
                { value: 305, text: 'Kuusamo' },
                { value: 312, text: 'Kyyjärvi' },
                { value: 316, text: 'Kärkölä' },
                { value: 317, text: 'Kärsämäki' },
                { value: 318, text: 'Kökar' },
                { value: 398, text: 'Lahti' },
                { value: 399, text: 'Laihia' },
                { value: 400, text: 'Laitila' },
                { value: 407, text: 'Lapinjärvi' },
                { value: 402, text: 'Lapinlahti' },
                { value: 403, text: 'Lappajärvi' },
                { value: 405, text: 'Lappeenranta' },
                { value: 408, text: 'Lapua' },
                { value: 410, text: 'Laukaa' },
                { value: 416, text: 'Lemi' },
                { value: 417, text: 'Lemland' },
                { value: 418, text: 'Lempäälä' },
                { value: 420, text: 'Leppävirta' },
                { value: 421, text: 'Lestijärvi' },
                { value: 422, text: 'Lieksa' },
                { value: 423, text: 'Lieto' },
                { value: 425, text: 'Liminka' },
                { value: 426, text: 'Liperi' },
                { value: 444, text: 'Lohja' },
                { value: 430, text: 'Loimaa' },
                { value: 433, text: 'Loppi' },
                { value: 434, text: 'Loviisa' },
                { value: 435, text: 'Luhanka' },
                { value: 436, text: 'Lumijoki' },
                { value: 438, text: 'Lumparland' },
                { value: 440, text: 'Luoto' },
                { value: 441, text: 'Luumäki' },
                { value: 475, text: 'Maalahti' },
                { value: 478, text: 'Maarianhamina - Mariehamn' },
                { value: 480, text: 'Marttila' },
                { value: 481, text: 'Masku' },
                { value: 483, text: 'Merijärvi' },
                { value: 484, text: 'Merikarvia' },
                { value: 489, text: 'Miehikkälä' },
                { value: 491, text: 'Mikkeli' },
                { value: 494, text: 'Muhos' },
                { value: 495, text: 'Multia' },
                { value: 498, text: 'Muonio' },
                { value: 499, text: 'Mustasaari' },
                { value: 500, text: 'Muurame' },
                { value: 503, text: 'Mynämäki' },
                { value: 504, text: 'Myrskylä' },
                { value: 505, text: 'Mäntsälä' },
                { value: 508, text: 'Mänttä-Vilppula' },
                { value: 507, text: 'Mäntyharju' },
                { value: 529, text: 'Naantali' },
                { value: 531, text: 'Nakkila' },
                { value: 535, text: 'Nivala' },
                { value: 536, text: 'Nokia' },
                { value: 538, text: 'Nousiainen' },
                { value: 541, text: 'Nurmes' },
                { value: 543, text: 'Nurmijärvi' },
                { value: 545, text: 'Närpiö' },
                { value: 560, text: 'Orimattila' },
                { value: 561, text: 'Oripää' },
                { value: 562, text: 'Orivesi' },
                { value: 563, text: 'Oulainen' },
                { value: 564, text: 'Oulu' },
                { value: 309, text: 'Outokumpu' },
                { value: 576, text: 'Padasjoki' },
                { value: 577, text: 'Paimio' },
                { value: 578, text: 'Paltamo' },
                { value: 445, text: 'Parainen' },
                { value: 580, text: 'Parikkala' },
                { value: 581, text: 'Parkano' },
                { value: 599, text: 'Pedersören kunta' },
                { value: 583, text: 'Pelkosenniemi' },
                { value: 854, text: 'Pello' },
                { value: 584, text: 'Perho' },
                { value: 592, text: 'Petäjävesi' },
                { value: 593, text: 'Pieksämäki' },
                { value: 595, text: 'Pielavesi' },
                { value: 598, text: 'Pietarsaari' },
                { value: 601, text: 'Pihtipudas' },
                { value: 604, text: 'Pirkkala' },
                { value: 607, text: 'Polvijärvi' },
                { value: 608, text: 'Pomarkku' },
                { value: 609, text: 'Pori' },
                { value: 611, text: 'Pornainen' },
                { value: 638, text: 'Porvoo' },
                { value: 614, text: 'Posio' },
                { value: 615, text: 'Pudasjärvi' },
                { value: 616, text: 'Pukkila' },
                { value: 619, text: 'Punkalaidun' },
                { value: 620, text: 'Puolanka' },
                { value: 623, text: 'Puumala' },
                { value: 624, text: 'Pyhtää' },
                { value: 625, text: 'Pyhäjoki' },
                { value: 626, text: 'Pyhäjärvi' },
                { value: 630, text: 'Pyhäntä' },
                { value: 631, text: 'Pyhäranta' },
                { value: 635, text: 'Pälkäne' },
                { value: 636, text: 'Pöytyä' },
                { value: 678, text: 'Raahe' },
                { value: 710, text: 'Raasepori' },
                { value: 680, text: 'Raisio' },
                { value: 681, text: 'Rantasalmi' },
                { value: 683, text: 'Ranua' },
                { value: 684, text: 'Rauma' },
                { value: 686, text: 'Rautalampi' },
                { value: 687, text: 'Rautavaara' },
                { value: 689, text: 'Rautjärvi' },
                { value: 691, text: 'Reisjärvi' },
                { value: 694, text: 'Riihimäki' },
                { value: 697, text: 'Ristijärvi' },
                { value: 698, text: 'Rovaniemi' },
                { value: 700, text: 'Ruokolahti' },
                { value: 702, text: 'Ruovesi' },
                { value: 704, text: 'Rusko' },
                { value: 707, text: 'Rääkkylä' },
                { value: 729, text: 'Saarijärvi' },
                { value: 732, text: 'Salla' },
                { value: 734, text: 'Salo' },
                { value: 736, text: 'Saltvik' },
                { value: 790, text: 'Sastamala' },
                { value: 738, text: 'Sauvo' },
                { value: 739, text: 'Savitaipale' },
                { value: 740, text: 'Savonlinna' },
                { value: 742, text: 'Savukoski' },
                { value: 743, text: 'Seinäjoki' },
                { value: 746, text: 'Sievi' },
                { value: 747, text: 'Siikainen' },
                { value: 748, text: 'Siikajoki' },
                { value: 791, text: 'Siikalatva' },
                { value: 749, text: 'Siilinjärvi' },
                { value: 751, text: 'Simo' },
                { value: 753, text: 'Sipoo' },
                { value: 755, text: 'Siuntio' },
                { value: 758, text: 'Sodankylä' },
                { value: 759, text: 'Soini' },
                { value: 761, text: 'Somero' },
                { value: 762, text: 'Sonkajärvi' },
                { value: 765, text: 'Sotkamo' },
                { value: 766, text: 'Sottunga' },
                { value: 768, text: 'Sulkava' },
                { value: 771, text: 'Sund' },
                { value: 777, text: 'Suomussalmi' },
                { value: 778, text: 'Suonenjoki' },
                { value: 781, text: 'Sysmä' },
                { value: 783, text: 'Säkylä' },
                { value: 831, text: 'Taipalsaari' },
                { value: 832, text: 'Taivalkoski' },
                { value: 833, text: 'Taivassalo' },
                { value: 834, text: 'Tammela' },
                { value: 837, text: 'Tampere' },
                { value: 844, text: 'Tervo' },
                { value: 845, text: 'Tervola' },
                { value: 846, text: 'Teuva' },
                { value: 848, text: 'Tohmajärvi' },
                { value: 849, text: 'Toholampi' },
                { value: 850, text: 'Toivakka' },
                { value: 851, text: 'Tornio' },
                { value: 853, text: 'Turku' },
                { value: 857, text: 'Tuusniemi' },
                { value: 858, text: 'Tuusula' },
                { value: 859, text: 'Tyrnävä' },
                { value: 886, text: 'Ulvila' },
                { value: 887, text: 'Urjala' },
                { value: 889, text: 'Utajärvi' },
                { value: 890, text: 'Utsjoki' },
                { value: 892, text: 'Uurainen' },
                { value: 893, text: 'Uusikaarlepyy' },
                { value: 895, text: 'Uusikaupunki' },
                { value: 785, text: 'Vaala' },
                { value: 905, text: 'Vaasa' },
                { value: 908, text: 'Valkeakoski' },
                { value: 92, text: 'Vantaa' },
                { value: 915, text: 'Varkaus' },
                { value: 918, text: 'Vehmaa' },
                { value: 921, text: 'Vesanto' },
                { value: 922, text: 'Vesilahti' },
                { value: 924, text: 'Veteli' },
                { value: 925, text: 'Vieremä' },
                { value: 927, text: 'Vihti' },
                { value: 931, text: 'Viitasaari' },
                { value: 934, text: 'Vimpeli' },
                { value: 935, text: 'Virolahti' },
                { value: 936, text: 'Virrat' },
                { value: 941, text: 'Vårdö' },
                { value: 946, text: 'Vöyri' },
                { value: 976, text: 'Ylitornio' },
                { value: 977, text: 'Ylivieska' },
                { value: 980, text: 'Ylöjärvi' },
                { value: 981, text: 'Ypäjä' },
                { value: 989, text: 'Ähtäri' },
                { value: 992, text: 'Äänekoski' }
            ],
            leafletScreenshotOptions: {
                cropImageByInnerWH: true,
                hidden: true,
                preventDownload: false,
                domtoimageOptions: {},
                position: 'topleft',
                screenName: 'screen',
                iconUrl: 'noicon',
                hideElementsWithSelectors: ['.leaflet-control-container'],
                mimeType: 'image/png',
                caption: null,
                captionFontSize: 15,
                captionFont: 'Arial',
                captionColor: 'black',
                captionBgColor: 'white',
                captionOffset: 5,
                // eslint-disable-next-line
                onPixelDataFail: async function({ node, plugin, error, mapPane, domtoimageOptions }) {
                    return plugin._getPixelDataOfNormalMap(domtoimageOptions)
                }
            }
        }
    },
    computed: {
        mapSettings: {
            get() {
                const settings = this.$store && this.$store.state.mapSettings || {};
                return this.convertMapSettings(settings);
            },
            set(value) {
                this.$store.commit(
                    'storeMapSettings',
                    value
                )
            }
        }
    },
    methods: {
        async saveMapSettings() {
            return await this.upsertUserPreferences('mapSettings', this.cleanSettings(this.mapSettings));
        },
        // When vue supports it, replace calls to this with optional chaining
        // eg. this.mapSettings?.my?.path ?? myDefaultValue
        getMapSettingsIn(path, defaultValue = undefined) {
            let settings = this.mapSettings;
            for (const index in path) {
                settings = settings[path[index]];
                if (settings == null) {
                    return defaultValue;
                }
            }
            return settings
        },
        cleanSettings(settings) {
            return {
                "baseMap": settings.baseMap,
                "buttons": settings.buttons,
                "center": settings.center,
                "leaflet": settings.leaflet,
                "here": settings.here
            }
        },
        convertMapSettings(settings) {
            const mapToggles = settings.mapToggles;
            if (mapToggles) {
                delete settings.mapToggles;
                if (settings.buttons === undefined) {
                    settings.buttons = {};
                }
                settings.buttons.vehicles = mapToggles.vehiclesEnabled;
                settings.buttons.observations = mapToggles.observationsEnabled;
                settings.buttons.users = mapToggles.usersEnabled;
                settings.buttons.skiing =
                    mapToggles.skiingSelectedCity ? {city: mapToggles.skiingSelectedCity}
                        : mapToggles.skiingEnabled ? {}
                            : undefined;
                settings.buttons.storages = mapToggles.storagesEnabled;
                settings.buttons.stations = mapToggles.stationsEnabled;
                settings.buttons.roadSigns = mapToggles.roadSignsEnabled;
                settings.buttons.workAssignments = mapToggles.workAssignmentsEnabled;
                setTimeout(this.saveMapSettings, 500);
            }
            return settings;
        },
        updateMapSettings(value) {
            this.mapSettings = deepmerge(this.mapSettings, value, { arrayMerge: overwriteMerge });
        },
        getMarkerDiv(markerStore, type) {
            switch (type) {
                case this.OBSERVATION: return markerStore.getObservationMarkerIcon()
                case this.WORK_ASSIGNMENT: return markerStore.getWorkAssignmentMarkerIcon()
                case this.MATERIAL_STORAGE: return markerStore.getStorageMarkerGenericIcon()
                case this.USER: return markerStore.getPersonMarkerIcon()
                case this.STREET_LIGHT: return markerStore.getStreetLightIcon()
                case this.POWER_CENTER: return markerStore.getPowerStationIcon()
                case this.DRAINS: return markerStore.getDrainIcon()
                case this.VEHICLE: return markerStore.getActiveCarIcon()
                case this.USER_ALERT: return markerStore.getAlertMarkerIcon()
                case this.CABLE: return markerStore.getCableIcon(type)
                case this.MIXED_WASTE_BINS: return markerStore.getWasteBinGeneralIcon()
                case this.BRIDGE: return markerStore.getSvgMarker(bridgeSvg, null, null, '2em', '2em');
            }
            return null
        },
        getMarkerTypeName(type) {
            switch (type) {
                case this.OBSERVATION: return this.$t('map.create_observation')
                case this.WORK_ASSIGNMENT: return this.$t('map.create_work_assignment')
                case this.MATERIAL_STORAGE: return this.$t('materialstorage.title')
                case this.STREET_LIGHT: return this.$t('map.add_street_light')
                case this.POWER_CENTER: return this.$t('map.add_power_center')
                case this.CABLE: return this.$t('cables.cable')
                case this.DRAINS: return this.$t('map.add_sewer_drain')
                case this.SEWERS: return this.$t('storm_sewers.sewers')
                case this.VEHICLE: return this.$t('tracking_devices.vehicle')
                case this.USER: return this.$t('work_time.person')
                case this.USER_ALERT: return this.$t('menu.user_alerts')
                case this.TRAFFIC_CONTROL_ITEM: return this.$t('traffic_control.modal_title')
                case this.MIXED_WASTE_BINS: return this.$t('map.add_mixed_waste_bin')
            }
            return null
        }
    }
}

export const userTracking = {
    props: {
        selectedMap: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            watchUserPositionId: null,
            isLoadingPosition: false
        }
    },

    methods: {
        userPinOnMap() {
            return this.USER_LOCATION in this.markers && this.markers[this.USER_LOCATION][this.userMarkerId] !== undefined
        },

        watchUserPosition: function () {
            if (this.watchUserPositionId) {
                return this.showUserMarkerPosition()
            }
            this.isLoadingPosition = true;
            if (navigator.geolocation) {
                if (!this.watchUserPositionId) {
                    this.isLoadingPosition = true
                }
                this.watchUserPositionId = navigator.geolocation.watchPosition(
                    (pos) => this.successPosition(pos),
                    () => this.failurePosition(),
                    { timeout: Infinity, enableHighAccuracy: true, maximumAge: Infinity }
                )
            }
        },

        successPosition: function (pos) {
            if (pos.message || pos.code) return
            this.showPosition(pos, true, this.watchUserPositionId != null)
            if (this.isLoadingPosition) this.isLoadingPosition = false
        },

        failurePosition: function () {
            this.isLoadingPosition = false;
        },

        clearWatchUserPosition: function () {
            if (navigator.geolocation && this.watchUserPositionId) {
                navigator.geolocation.clearWatch(this.watchUserPositionId)
                this.watchUserPositionId = null
            }
        },

        showUserMarkerPosition: function () {
            if (this.userPinOnMap()) {
                const userMarker = this.markers[this.USER_LOCATION][this.userMarkerId];
                if (userMarker) {
                    const { lat, lng } = userMarker.getLatLng()
                    this.showPosition({ coords: { latitude: lat, longitude: lng } }, false, this.watchUserPositionId != null)
                }
            }
        },
    },

    computed: {
        currentMapCenter() {
            return this.getMapCenter()
        },
    },

    mounted() {
        this.clearWatchUserPosition()
    },
    beforeUnmount() {
        navigator.geolocation.clearWatch(this.watchUserPositionId)
        this.watchUserPositionId = null
    }
}
